import type {
  RefundRepairArgs,
  RefundRepairExecResponse,
  RefundRepairExecVariables,
  RepairType,
} from '@src/types';

import {
  exec,
  getApiToken,
} from '../utils';

const gql = String.raw;

/**
 * Refunds a repair by UUID
 * Automatically exchanges JWT for badge token if needed
 * @param args - Repair UUID
 * @returns Promise resolving to refunded repair data
 */
export const refundRepair = async (
  args: RefundRepairArgs
): Promise<RepairType> => {
  const { token } = sessionStorage;

  const apiToken = await getApiToken(token);

  const variables = {
    ...args,
    token: apiToken,
  };

  const mutation = gql`
    mutation refundRepair(
      $token: String!
      $repairUuid: String!
    ) {
      restUser(token: $token) {
        repair(uuid: $repairUuid) {
          refundRepair {
            uuid
          }
        }
      }
    }
  `;

  const data = await exec<RefundRepairExecVariables, RefundRepairExecResponse>(
    mutation,
    {
      variables,
    }
  );

  return data.restUser.repair.refundRepair;
};
